import { useToast } from "@chakra-ui/react";
import firebase from "firebase";
import { useState } from "react";
import { useRegisterFcmTokenMutation } from "../graphql";

export function usePushNotification() {
  const toast = useToast();
  const [token, setToken] = useState("");
  const [isInit, setIsInt] = useState(false);
  const [registerToken] = useRegisterFcmTokenMutation();

  const init = () => {
    if (!isInit) {
      firebase.initializeApp({
        apiKey: "AIzaSyAGCL9YNhTbzz9tSItydTzv6TnRygKnEi4",
        authDomain: "sigal-40204.firebaseapp.com",
        projectId: "sigal-40204",
        storageBucket: "sigal-40204.appspot.com",
        messagingSenderId: "28776606887",
        appId: "1:28776606887:web:4b41d2efa2eb3c45b4ff82",
        measurementId: "G-DHKV4HJPJW",
      });
    }

    setIsInt(true);
  };

  const setPushNotificationToken = async () => {
    try {
      const messaging = firebase.messaging();
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        const currentToken = await messaging.getToken({
          vapidKey:
            "BOoO35e33zddp32YpwQBckRoA91bGYlJdKPlNCxTXPT3Nbw-xyAuITiIAAStWhuzQEUA7UHmSS_gI4OsXLloALs",
        });

        registerToken({
          variables: {
            token: currentToken,
          },
        });
        setToken(currentToken);

        toast({
          title: "Sukses",
          description: "Gati për të marrë njoftime",
        });
      } else {
        toast({
          title: "Problem",
          description: "Njoftimet nuk jane lidhur pasi keni refuzuar",
        });
      }
    } catch (error) {
      console.error(error);
      toast({
        title: "Problem",
        description: "Njoftimet nuk jane lidhur.",
      });
    }
  };

  return { init, setPushNotificationToken };
}
